import React from 'react';
import { Tooltip } from 'antd';
import { profileFormatBytes, profileHumanFormatBytes } from '../../middleware';
import { formatByte } from '../../instruments';
import { ITrField, tF } from '../../translate';

type IShowDataBytes = {
    bytes?: number | null;
    isHumanView?: boolean;
    noDataText?: ITrField;
};

export const ShowDataBytes: React.FC<IShowDataBytes> = ({ bytes, isHumanView, noDataText }: IShowDataBytes) => {
    const text = isHumanView ? profileHumanFormatBytes(bytes) : profileFormatBytes(bytes);
    return bytes !== null && bytes === undefined ? (
        <>{noDataText ? tF(noDataText) : text}</>
    ) : (
        <Tooltip title={`${formatByte(bytes)} B`}>{text}</Tooltip>
    );
};

export const showDataBytesText = ({ bytes, isHumanView, noDataText }: IShowDataBytes): string => {
    return bytes === undefined && !!noDataText
        ? tF(noDataText)
        : isHumanView
        ? profileHumanFormatBytes(bytes)
        : profileFormatBytes(bytes);
};
